export default __webpack_public_path__ + "static/media/chatton2.a5ab328b.jpg";